import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Switch } from '../../../components/ui/switch';
import { Button } from '../../../components/ui/button';
import { Save } from 'lucide-react';

export function MapsSettings({ data, setData, isSaving, onSave, IntegrationStatus }) {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-bold text-slate-900 font-[Poppins]">Maps Integration</h3>
          <p className="text-sm text-slate-500 mt-1">For address search and location display</p>
        </div>
        <div className="flex items-center gap-3">
          <IntegrationStatus enabled={data.enabled} />
          <Switch
            checked={data.enabled}
            onCheckedChange={(checked) => setData(prev => ({ ...prev, enabled: checked }))}
            data-testid="maps-toggle"
          />
        </div>
      </div>
      
      <div className="space-y-4">
        <div>
          <Label>Provider</Label>
          <select
            value={data.provider}
            onChange={(e) => setData(prev => ({ ...prev, provider: e.target.value }))}
            className="w-full h-12 mt-1.5 border border-stone-200 rounded-lg px-3"
            data-testid="maps-provider"
          >
            <option value="google">Google Maps</option>
            <option value="mapbox">Mapbox</option>
            <option value="here">HERE Maps</option>
          </select>
        </div>
        
        <div>
          <Label>API Key</Label>
          <Input
            type="password"
            placeholder="Your maps API key"
            value={data.api_key}
            onChange={(e) => setData(prev => ({ ...prev, api_key: e.target.value }))}
            className="h-12 mt-1.5 font-mono"
            data-testid="maps-api-key"
          />
          <p className="text-xs text-slate-500 mt-1">
            {data.provider === 'google' && 'Get your key from Google Cloud Console → APIs & Services → Credentials'}
            {data.provider === 'mapbox' && 'Get your key from Mapbox account → Access tokens'}
            {data.provider === 'here' && 'Get your key from HERE Developer Portal → Projects → API Keys'}
          </p>
        </div>
      </div>
      
      <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mt-4">
        <p className="text-sm text-blue-800">
          <strong>Required APIs:</strong> If using Google Maps, enable these in your Cloud Console:
        </p>
        <ul className="text-sm text-blue-700 mt-2 space-y-1">
          <li>• Maps JavaScript API</li>
          <li>• Places API</li>
          <li>• Geocoding API</li>
        </ul>
      </div>
      
      <Button 
        onClick={onSave}
        disabled={isSaving}
        className="mt-6 bg-slate-900 hover:bg-slate-800"
        data-testid="save-maps-btn"
      >
        <Save className="w-4 h-4 mr-2" />
        {isSaving ? 'Saving...' : 'Save Maps Settings'}
      </Button>
    </div>
  );
}
